import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PendingCollageRequest from '../../components/admin/pendingRequests/PendingCollageRequest'
import PendingStudentRequest from '../../components/admin/pendingRequests/PendingStudentRequest'
import PendingReportList from '../../components/admin/PendingReportList'
import Badge from '@mui/material/Badge';
import api from '../../api';

export default function PendingRequests() {
  const [value, setValue] = React.useState('1');
  const [reportCount, setReportCount] = React.useState(0);
  const [collegeCount, setCollegeCount] = React.useState(0);
  const [studentCount, setStudentCount] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Fetch pending counts for reports, colleges, and students
  React.useEffect(() => {
    const fetchPendingCounts = async () => {
      try {
        const { data } = await api.get(`${process.env.REACT_APP_API_BASE_URL}admin/pending-counts`);
        const { reportCount, collegeCount, studentCount } = data;

        setReportCount(reportCount);
        setCollegeCount(collegeCount);
        setStudentCount(studentCount);
      } catch (error) {
        console.error("Error fetching pending counts:", error);
      }
    };

    fetchPendingCounts();
  }, []);

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab 
              label={
                <div>
                  Report List 
                  <Badge 
                    color="secondary" 
                    badgeContent={reportCount} 
                    showZero 
                    sx={{ marginLeft: 4 }}  
                  />
                </div>
              }
              value="1"
            />
            <Tab 
              label={
                <div>
                  Colleges 
                  <Badge 
                    color="secondary" 
                    badgeContent={collegeCount} 
                    showZero 
                    sx={{ marginLeft: 4 }}  
                  />
                </div>
              }
              value="2"
            />
            <Tab 
              label={
                <div>
                  Students 
                  <Badge 
                    color="secondary" 
                    badgeContent={studentCount} 
                    showZero 
                    sx={{ marginLeft: 4 }}  
                  />
                </div>
              }
              value="3"
            />
          </TabList>
        </Box>
        <TabPanel sx={{ padding: 1 }} value="1"><PendingReportList /></TabPanel>
        <TabPanel sx={{ padding: 1 }} value="2"><PendingCollageRequest /></TabPanel>
        <TabPanel sx={{ padding: 1 }} value="3"><PendingStudentRequest /></TabPanel>
      </TabContext>
    </Box>
  );
}
